
define('text!views/shop/instore/merchants_see_all_btn.html',[],function () { return '<span class="merchants-see-all-plus-icon"><%= enums.svg.rightArrowIcon %></span>\r\n<div class="merchants-see-all-content-container">\r\n\t<p class="merchants-see-all-text">See All Merchants</p>\r\n</div>';});

